var render = function () {
  var _vm$user, _vm$user2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._m(0), _c('div', {
    staticClass: "table-style table-style--default"
  }, [_c('div', {
    staticClass: "table-style__row"
  }, [_vm._m(1), _c('div', {
    staticClass: "table-style__td"
  }, [_c('v-text-field', {
    staticClass: "w-100 mw-lg-500px",
    attrs: {
      "type": "text",
      "name": "username",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.username,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "username", $$v);
      },
      expression: "user.username"
    }
  })], 1)]), _c('div', {
    staticClass: "table-style__row"
  }, [_vm._m(2), _c('div', {
    staticClass: "table-style__td"
  }, [_c('v-text-field', {
    staticClass: "w-100 mw-lg-500px",
    attrs: {
      "type": "password",
      "name": "password",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.password,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "password", $$v);
      },
      expression: "user.password"
    }
  }), _c('small', {
    staticClass: "text-grey text-grey--right"
  }, [_vm._v("(영문대소문자/숫자/특수문자 중 2가지 이상 조합, 8 - 16자)")])], 1)]), _c('div', {
    staticClass: "table-style__row"
  }, [_vm._m(3), _c('div', {
    staticClass: "table-style__td"
  }, [_c('v-text-field', {
    staticClass: "w-100 mw-lg-500px",
    attrs: {
      "type": "password",
      "name": "password2",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.passwordConfirm,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "passwordConfirm", $$v);
      },
      expression: "user.passwordConfirm"
    }
  })], 1)]), _c('div', {
    staticClass: "table-style__row"
  }, [_vm._m(4), _c('div', {
    staticClass: "table-style__td"
  }, [_c('v-text-field', {
    staticClass: "w-100 mw-lg-500px",
    attrs: {
      "type": "text",
      "name": "name",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.name,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "name", $$v);
      },
      expression: "user.name"
    }
  })], 1)]), _c('div', {
    staticClass: "table-style__row"
  }, [_vm._m(5), _c('div', {
    staticClass: "table-style__td"
  }, [_c('v-text-field', {
    staticClass: "w-100 mw-lg-500px",
    attrs: {
      "type": "text",
      "name": "ceoName",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.ceoName,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "ceoName", $$v);
      },
      expression: "user.ceoName"
    }
  })], 1)]), _c('div', {
    staticClass: "table-style__row"
  }, [_c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("기업설립일")]), _c('div', {
    staticClass: "table-style__td"
  }, [_c('v-text-field', {
    staticClass: "w-100 mw-lg-500px",
    attrs: {
      "type": "date",
      "name": "foundAt",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.foundAt,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "foundAt", $$v);
      },
      expression: "user.foundAt"
    }
  })], 1)]), _c('div', {
    staticClass: "table-style__row"
  }, [_vm._m(6), _c('div', {
    staticClass: "table-style__td"
  }, [_c('v-text-field', {
    staticClass: "w-100 mw-lg-500px",
    attrs: {
      "type": "text",
      "name": "businessRegisitrationNumber",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.businessRegisitrationNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "businessRegisitrationNumber", $$v);
      },
      expression: "user.businessRegisitrationNumber"
    }
  })], 1)]), _c('div', {
    staticClass: "table-style__row"
  }, [_c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("국가")]), _c('div', {
    staticClass: "table-style__td"
  }, [_c('v-text-field', {
    staticClass: "w-100 mw-lg-500px",
    attrs: {
      "type": "text",
      "name": "nation",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.nation,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "nation", $$v);
      },
      expression: "user.nation"
    }
  })], 1)]), _c('div', {
    staticClass: "table-style__row"
  }, [_vm._m(7), _c('div', {
    staticClass: "table-style__td"
  }, [_c('div', {
    staticClass: "mw-lg-500px"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-text-field', {
    staticClass: "w-100",
    attrs: {
      "type": "tel",
      "name": "phone1",
      "maxlength": "4",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.phone1,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "phone1", $$v);
      },
      expression: "user.phone1"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-text-field', {
    staticClass: "w-100",
    attrs: {
      "type": "tel",
      "name": "phone2",
      "maxlength": "4",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.phone2,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "phone2", $$v);
      },
      expression: "user.phone2"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-text-field', {
    staticClass: "w-100",
    attrs: {
      "type": "tel",
      "name": "phone3",
      "maxlength": "4",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.phone3,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "phone3", $$v);
      },
      expression: "user.phone3"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "w-100 w-sm-120px v-btn--input",
    attrs: {
      "tile": "",
      "color": "primary"
    },
    on: {
      "click": _vm.certify
    }
  }, [_vm._v("본인인증")])], 1)], 1)], 1)])]), _c('div', {
    staticClass: "table-style__row"
  }, [_vm._m(8), _c('div', {
    staticClass: "table-style__td"
  }, [_c('div', {
    staticClass: "mw-lg-500px"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-text-field', {
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "name": "email1",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.email1,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "email1", $$v);
      },
      expression: "user.email1"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("@")]), _c('v-col', [_c('v-text-field', {
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "name": "email2",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.email2,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "email2", $$v);
      },
      expression: "user.email2"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.email3,
      expression: "user.email3"
    }],
    staticClass: "select w-100",
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });

        _vm.$set(_vm.user, "email3", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, function ($event) {
        _vm.user.email2 = _vm.user.email3;
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("직접입력")]), _c('option', {
    domProps: {
      "value": "naver.com"
    }
  }, [_vm._v("naver.com")]), _c('option', {
    domProps: {
      "value": "daum.net"
    }
  }, [_vm._v("daum.net")]), _c('option', {
    domProps: {
      "value": "google.com"
    }
  }, [_vm._v("google.com")])])])], 1)], 1)])]), _c('div', {
    staticClass: "table-style__row"
  }, [_vm._m(9), _c('div', {
    staticClass: "table-style__td"
  }, [_c('div', {
    staticClass: "mw-lg-500px"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-text-field', {
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "placeholder": "우편번호",
      "readonly": "",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "click": _vm.searchAddress
    },
    model: {
      value: _vm.user.postcode,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "postcode", $$v);
      },
      expression: "user.postcode"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-btn', {
    staticClass: "w-100 v-btn--input",
    attrs: {
      "tile": "",
      "color": "primary"
    },
    on: {
      "click": _vm.searchAddress
    }
  }, [_vm._v("검색")])], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "placeholder": "기본주소",
      "readonly": "",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "click": _vm.searchAddress
    },
    model: {
      value: _vm.user.address1,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "address1", $$v);
      },
      expression: "user.address1"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "placeholder": "상세주소",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.address2,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "address2", $$v);
      },
      expression: "user.address2"
    }
  })], 1)], 1)], 1)])]), _c('div', {
    staticClass: "table-style__row"
  }, [_c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("홈페이지")]), _c('div', {
    staticClass: "table-style__td"
  }, [_c('v-text-field', {
    staticClass: "w-100 mw-lg-500px",
    attrs: {
      "type": "text",
      "name": "website",
      "outlined": "",
      "hide-details": "",
      "placeholder": "https://"
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.website,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "website", $$v);
      },
      expression: "user.website"
    }
  })], 1)]), _c('div', {
    staticClass: "table-style__row"
  }, [_vm._m(10), _c('div', {
    staticClass: "table-style__td"
  }, [_c('v-text-field', {
    staticClass: "w-100 mw-lg-500px",
    attrs: {
      "type": "text",
      "name": "workerName",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.workerName,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "workerName", $$v);
      },
      expression: "user.workerName"
    }
  })], 1)]), _c('div', {
    staticClass: "table-style__row"
  }, [_vm._m(11), _c('div', {
    staticClass: "table-style__td"
  }, [_c('div', {
    staticClass: "mw-lg-500px"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-text-field', {
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "name": "workerEmail1",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.workerEmail1,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "workerEmail1", $$v);
      },
      expression: "user.workerEmail1"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("@")]), _c('v-col', [_c('v-text-field', {
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "name": "workerEmail2",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.workerEmail2,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "workerEmail2", $$v);
      },
      expression: "user.workerEmail2"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.user.workerEmail3,
      expression: "user.workerEmail3"
    }],
    staticClass: "select w-100",
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });

        _vm.$set(_vm.user, "workerEmail3", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, function ($event) {
        _vm.user.workerEmail2 = _vm.user.workerEmail3;
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("직접입력")]), _c('option', {
    domProps: {
      "value": "naver.com"
    }
  }, [_vm._v("naver.com")]), _c('option', {
    domProps: {
      "value": "daum.net"
    }
  }, [_vm._v("daum.net")]), _c('option', {
    domProps: {
      "value": "google.com"
    }
  }, [_vm._v("google.com")])])])], 1)], 1)])]), _c('div', {
    staticClass: "table-style__row"
  }, [_vm._m(12), _c('div', {
    staticClass: "table-style__td"
  }, [_c('div', {
    staticClass: "mw-lg-500px"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-text-field', {
    staticClass: "w-100",
    attrs: {
      "type": "tel",
      "name": "workerPhone1",
      "maxlength": "4",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.workerPhone1,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "workerPhone1", $$v);
      },
      expression: "user.workerPhone1"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-text-field', {
    staticClass: "w-100",
    attrs: {
      "type": "tel",
      "name": "workerPhone2",
      "maxlength": "4",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.workerPhone2,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "workerPhone2", $$v);
      },
      expression: "user.workerPhone2"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-text-field', {
    staticClass: "w-100",
    attrs: {
      "type": "tel",
      "name": "workerPhone3",
      "maxlength": "4",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": _vm.input
    },
    model: {
      value: _vm.user.workerPhone3,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "workerPhone3", $$v);
      },
      expression: "user.workerPhone3"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "w-100 w-sm-120px v-btn--input",
    attrs: {
      "tile": "",
      "color": "primary"
    },
    on: {
      "click": _vm.certify
    }
  }, [_vm._v("본인인증")])], 1)], 1)], 1)])]), _c('div', {
    staticClass: "table-style__row"
  }, [_vm._m(13), _c('div', {
    staticClass: "table-style__td"
  }, [((_vm$user = _vm.user) === null || _vm$user === void 0 ? void 0 : _vm$user.notify) ? _c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, _vm._l((_vm$user2 = _vm.user) === null || _vm$user2 === void 0 ? void 0 : _vm$user2.notify, function (item, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "auto"
      }
    }, [_c('div', {
      staticClass: "d-flex flex-wrap align-center"
    }, [_c('v-checkbox', {
      staticClass: "d-inline-flex",
      attrs: {
        "label": item.text,
        "hide-details": ""
      },
      on: {
        "input": _vm.input
      },
      model: {
        value: item.enabled,
        callback: function callback($$v) {
          _vm.$set(item, "enabled", $$v);
        },
        expression: "item.enabled"
      }
    }), item.enabled ? [_c('v-text-field', {
      staticClass: "ml-8",
      attrs: {
        "outlined": "",
        "placeholder": "연락처",
        "hide-details": ""
      },
      on: {
        "input": _vm.input
      },
      model: {
        value: item.contact,
        callback: function callback($$v) {
          _vm.$set(item, "contact", $$v);
        },
        expression: "item.contact"
      }
    })] : _vm._e()], 2)]);
  }), 1) : _vm._e()], 1)])]), _c('div', {
    staticClass: "bottom-button"
  }, [_c('div', {
    staticClass: "v-btn--group v-btn--group--large"
  }, [_c('v-btn', {
    staticClass: "w-100 mw-220px",
    attrs: {
      "x-large": "",
      "outlined": "",
      "color": "grey-cb"
    },
    on: {
      "click": function click($event) {
        return _vm.cancel();
      }
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("취소하기")])]), _c('v-btn', {
    staticClass: "w-100 mw-220px",
    attrs: {
      "x-large": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.submit();
      }
    }
  }, [_vm._v("회원가입")])], 1)]), _c('daum-postcode', {
    ref: "daum-postcode",
    on: {
      "change": _vm.setAddress
    }
  }), _c('kcp-cert', {
    ref: "kcp-cert",
    on: {
      "input": _vm.verify
    }
  })], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-6"
  }, [_c('p', {
    staticClass: "font-size-14 text-right"
  }, [_c('span', {
    staticStyle: {
      "color": "rgb(255, 0, 0)"
    }
  }, [_vm._v("*")]), _vm._v(" 필수입력입니다.")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("아이디 "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("비밀번호 "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("비밀번호 확인 "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("기업명 "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("대표자명 "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("사업자등록번호 "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("연락처 "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("이메일 "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("주소 "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("담당자 이름 "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("담당자 이메일 "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("담당자 연락처 "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("정보수신방법 "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("*")])]);
}]

export { render, staticRenderFns }